/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/gensetstatus.cs.d.ts" />
import * as React from 'react';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { RCUtils } from './../../RCUtils';
import * as Autosuggest from 'react-autosuggest';
import Select from 'react-select';
var Config: any = require('../../Config.json');

interface SearchState {
    Oemtypes: server.vRefOEMTypeUIModel[],
    RefCountry: server.RefCountryModel[],
    RefGeofences: string[],
    suggestionsFenceId: any[],
    targetId: string,
    Filters: server.ReeferSearchFilters,
    AssetStates: any[],
    stayOpen: boolean,
    disabled: boolean,
    removeSelected: boolean,
    rtl: boolean,
}
const assetStates = [
    { label: "Active", value: 'A' },
    { label: "Disconnected", value: 'D' },
    { label: "Retired", value: 'R' },
];
export class GensetStatusSearch extends React.Component<any, SearchState> {
    constructor(props: any) {
        super(props);
        var customAttributesInfo = {};
        var filter: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedGeofence: '', SelectedGeofenceInside: '', SelectedInterval: '', SelectedReefer: '', SelectedAssetStates: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,
            SelectedVesselCode: '', StatusFilters: [], AllReefers: '', CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedCall: '',
            SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: [] //WI-26881
        };
        
        if (this.props.stateData != null && this.props.stateData != undefined && this.props.stateData != null) {
            filter.SelectedOem = this.props.stateData.SelectedOem == null ? '' : this.props.stateData.SelectedOem;
            filter.SelectedCountry = this.props.stateData.SelectedCountry == null ? '' : this.props.stateData.SelectedCountry;
            filter.SelectedAssetStates = this.props.stateData.SelectedAssetStates == null ? JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState : this.props.stateData.SelectedAssetStates;
            filter.SelectedGeofence = this.props.stateData.SelectedGeofence == null ? '' : this.props.stateData.SelectedGeofence;
            filter.SelectedGeofenceInside = this.props.stateData.SelectedGeofenceInside == null ? '' : this.props.stateData.SelectedGeofenceInside;
            filter.SelectedInterval = this.props.stateData.SelectedInterval == null ? '' : this.props.stateData.SelectedInterval;
            filter.SelectedReefer = this.props.stateData.SelectedReefer == null ? '' : this.props.stateData.SelectedReefer;
            filter.SelectedVesselCode = this.props.stateData.SelectedVesselCode == null ? '' : this.props.stateData.SelectedVesselCode;
            filter.SelectedVoyage = this.props.stateData.SelectedVoyage == null ? '' : this.props.stateData.SelectedVoyage;//WI-26881
            filter.SelectedVesselCD = this.props.stateData.SelectedVesselCD == null ? '' : this.props.stateData.SelectedVesselCD;//WI-26881
            filter.SelectedCall = this.props.stateData.SelectedCall == null ? '' : this.props.stateData.SelectedCall;//WI-26881
            filter.SelectedBookingNumber = this.props.stateData.SelectedBookingNumber == null ? '' : this.props.stateData.SelectedBookingNumber;
            filter.StatusFilters = this.props.stateData.StatusFilters;
            filter.AllReefers = this.props.stateData.AllReefers == null ? '' : this.props.stateData.AllReefers;
            filter.CustomAttributeFilters = customAttributesInfo;
        }

        this.state = {
            Oemtypes: [], RefGeofences: [], suggestionsFenceId: [],
            targetId: '', RefCountry: [], Filters: filter, stayOpen: false, disabled: false, removeSelected: false, rtl: false, AssetStates: assetStates
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetGeofences')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GeofenceList[]>)
            .then(data => {
                if (data.length > 0) {
                    var fenceData = data.map(fence => fence.Tag);
                    this.setState({ RefGeofences: fenceData });
                }
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/OemTypes')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.vRefOEMTypeUIModel[]>)
            .then(data => {
                this.setState({ Oemtypes: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/RefCountry')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.RefCountryModel[]>)
            .then(data => {
                this.setState({ RefCountry: data });
            });
    }

    InsideGeofencechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedGeofenceInside = null;
        else
            filters.SelectedGeofenceInside = Value;
        this.setState({
            Filters: filters
        });
    }

    //Vesselcodechange(event: React.FormEvent<HTMLInputElement>) {
    //    var filters = this.state.Filters;
    //    var Value: string = event.currentTarget.value;
    //    filters.SelectedVesselCode = Value;
    //    this.setState({
    //        Filters: filters
    //    });
    //}

    //Geofencechange(event: React.FormEvent<HTMLInputElement>) {
    //    var filters = this.state.Filters;
    //    var Value: string = event.currentTarget.value;
    //    filters.SelectedGeofence = Value;
    //    this.setState({
    //        Filters: filters
    //    });
    //}

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };

    getFenceNameSuggestions(value) {
        var geofences = this.state.RefGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };

    onChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedGeofence = newValue;

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    AssetStateChange(value) {
        var filters = this.state.Filters;
        filters.SelectedAssetStates = value;
        if (value == "")
            $('#InventoryState .Select-control').addClass("MandatoryBorder");
        else
            $('#InventoryState .Select-control').removeClass("MandatoryBorder");
        this.setState({ Filters: filters });
    }

    Assetschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        var commaValue = this.GetMultiLineCsv(Value);
        filters.SelectedReefer = commaValue;
        this.setState({
            Filters: filters
        });
    }

    //Reeferchange(event: React.FormEvent<HTMLInputElement>) {
    //    var filters = this.state.Filters;
    //    var Value: string = event.currentTarget.value;
    //    filters.SelectedReefer = Value;
    //    this.setState({
    //        Filters: filters
    //    });
    //}

    GetMultiLineCsv(value) {
        while (value.includes('\r') || value.includes('\n') || value.includes(';') || value.includes(' ')) {
            value = value.replace('\r'.toString(), ",");
            value = value.replace('\n'.toString(), ",");
            value = value.replace(';'.toString(), ",");
            value = value.replace(' '.toString(), ",");
        }

        while (value.includes(",,")) {
            value = value.replace(",,", ",");
        }
        return value;
    }

    Oemchange(event: React.FormEvent<HTMLSelectElement>) {

        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedOem = null;
        else
            filters.SelectedOem = Value;
        this.setState({
            Filters: filters
        });
    }

    Countrychange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedCountry = null;
        else
            filters.SelectedCountry = Value;
        this.setState({
            Filters: filters
        });
    }

    ReportingIntervalchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedInterval = null;
        else
            filters.SelectedInterval = Value;
        this.setState({
            Filters: filters
        });
    }

    ClearFilter() {
        var filters = this.state.Filters;
        filters.SelectedCountry = "";
        filters.SelectedGeofence = "";
        filters.SelectedGeofenceInside = "";
        filters.SelectedInterval = "";
        filters.SelectedOem = "";
        filters.SelectedReefer = "";
        filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;
        filters.SelectedVesselCode = "";
        filters.StatusFilters = [];

        this.setState({
            Filters: filters
        });
    }

    isNullOrEmpty(value) {
        return value == null || value === "";
    }

    ApplyFilter() {
        var filter = this.state.Filters;
        var that = this;
        this.state.Filters.AllReefers = "";
        this.state.Filters.StatusFilters = [];
        if (!this.isNullOrEmpty(this.state.Filters.SelectedCountry) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofence) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofenceInside)
            || !this.isNullOrEmpty(this.state.Filters.SelectedInterval) || !this.isNullOrEmpty(this.state.Filters.SelectedOem) || !this.isNullOrEmpty(this.state.Filters.SelectedReefer) || !this.isNullOrEmpty(this.state.Filters.SelectedVesselCode)) {
            if (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null) {//RCNG-1454
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            else {
                this.props.bindingGensetStatusGrid(this.state.Filters);
            }
        }
        else {
            this.state.Filters.AllReefers = "All Gensets";
            if (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            else {
                this.props.bindingGensetStatusGrid(this.state.Filters);
            }
        }
    }

    componentDidMount() {
        $(document).ready(function () {
            $('.advance-search').bind('keypress', function (e) {
                if (e.keyCode === 13) {
                    $('#button_search').trigger('click');
                }
            });
        });
    }

    public render() {
        const { suggestionsFenceId } = this.state;

        const FenceIdListinputProps = {
            id: 'geofenceID',
            placeholder: 'Geofence ID',
            value: this.state.Filters.SelectedGeofence,
            onChange: this.onChangeFenceId.bind(this)
        };
        var assetStates = this.state.AssetStates;
        if (assetStates != undefined && assetStates != null && assetStates.length > 0) {
            var assetStatesOptions = assetStates.map(function (states) {
                return (
                    { value: states.value, label: states.label }
                );
            });
        }
        return <div className='advance-search page-controls-container'>
            <form>
                <div className="row" >
                    <div className="col-md-1 col-sm-2  col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Genset ID(s):</label>
                    </div>
                    <div className="col-md-5 col-sm-10 col-xs-9" >
                        <textarea id='txtAssetId' className='form-control texarea-55' placeholder='Genset ID(s)' onChange={e => this.Assetschange(e)} value={this.state.Filters.SelectedReefer} ></textarea>
                    </div>
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>OEM Type:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectOemType' onChange={e => this.Oemchange(e)} value={this.state.Filters.SelectedOem}>
                            <option>---Select---</option>
                            {
                                this.state.Oemtypes.map((oem, index) =>
                                    <option key={oem.OEMTypeCD} value={oem.OEMTypeCD}>{oem.DisplayName}</option>
                                )}
                        </select>
                    </div>
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Geofence Status:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectInsideGeofence' onChange={e => this.InsideGeofencechange(e)} value={this.state.Filters.SelectedGeofenceInside}>
                            <option>---Select---</option>
                            <option value="1">Inside Geofence Only</option>
                            <option value="0">Outside Geofence Only</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-6" >
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Inventory State:</label>
                    </div>
                    <div className="col-md-5 col-sm-4 col-xs-9" id="InventoryState">
                        <Select.Creatable
                            closeOnSelect={!this.state.stayOpen}
                            disabled={this.state.disabled}
                            multi
                            onChange={this.AssetStateChange.bind(this)}
                            options={assetStatesOptions}
                            placeholder="Inventory State"
                            removeSelected={this.state.removeSelected}
                            rtl={this.state.rtl}
                            simpleValue
                            value={this.state.Filters.SelectedAssetStates}
                            minMenuHeight={30}
                            maxMenuHeight={30}
                            promptTextCreator={() => false}
                        />
                    </div>

                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Geofence:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9" >

                        <Autosuggest name="geofenceID" id="geofenceID"
                            suggestions={suggestionsFenceId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={FenceIdListinputProps}
                            highlightFirstSuggestion={true}
                        />

                    </div>


                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end">
                        <label className='col-form-label'>Country:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9" >

                        <select className='form-select' id='selectRefCountry' onChange={e => this.Countrychange(e)} value={this.state.Filters.SelectedCountry}>
                            <option>---Select---</option>
                            {
                                this.state.RefCountry.map((item, index) =>
                                    <option key={item.CountryCd + index} value={item.CountryCd}>{item.CountryName}</option>
                                )}
                        </select>
                    </div>
                </div>

                <div className="row mt-6" >

                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end">
                        <label className='col-form-label'>Reporting (min):</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectReportingInterval' onChange={e => this.ReportingIntervalchange(e)} value={this.state.Filters.SelectedInterval}>
                            <option>---Select---</option>
                            <option>10</option>
                            <option>15</option>
                            <option>30</option>
                            <option>60</option>
                            <option>120</option>
                            <option>240</option>
                        </select>
                    </div>
                    <div className="col-md-9 col-sm-6 col-xs-12" >
                        <div className='hstack gap-2 float-end'>
                            <button type='button' onClick={this.ClearFilter.bind(this)} className='btn btn-primary'>Clear</button>
                            <button type='button' id="button_search" onClick={this.ApplyFilter.bind(this)} className='btn btn-primary'>Search</button>
                        
                        </div>
                    </div>
                </div>
            </form>
        </div>;
    }
}
